// import React, { Component } from 'react'
// // import RecentUserActivity from './RecentUserActivity'
// import RecentManuscripts from './RecentManuscripts';
// import QuickActions from './QuickActions'
//
// class DashboardBottomWrapper extends Component {
//   render() {
//     const { data } = this.props // 👈 Destructure dashboard stats data from props
//
//     return (
//       <div className={'dashboardBottomRowWrapper'}>
//         {/* Left Column: User Activity Table */}
//         <div className={'dashboardLeftColumn'}>
//           <RecentManuscripts data={data} />
//         </div>
//
//         {/* Right Column: 6 Quick Action Navigation Cards */}
//         <QuickActions />
//       </div>
//     )
//   }
// }
//
// export default DashboardBottomWrapper
import React, { Component } from 'react';
import RecentManuscripts from './RecentManuscripts';
import QuickActions from './QuickActions';

class DashboardBottomWrapper extends Component {
  render() {
    const { data } = this.props;

    return (
      <div className="dashboardBottomRowWrapper">
        {/* Left Column: All Company Recent Manuscripts */}
        <div className="dashboardLeftColumn">
          <RecentManuscripts data={data} />
        </div>

        {/* Right Column: Quick Action Cards */}
        <QuickActions />
      </div>
    );
  }
}

export default DashboardBottomWrapper;